import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import FormControl from '@mui/material/FormControl'
import { Box, FormLabel } from '@mui/material'
import "./css/AddnewItem.css"
import { useState, useEffect } from "react"
import axios from "axios"
import api from "../config/backend"

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}))

function AddNewItem({ open, setOpen, setProductUpdatedRefresh }) {
    const [producType, setProductType] = useState("goods")
    const [productName, setProductName] = useState("")
    const [productUnit, setProductUnit] = useState(undefined)
    const [sellingPrice, setSellingPrice] = useState("")
    const [costPrice, setCostPrice] = useState("")
    const [productDescription, setProductDescription] = useState("")
    const [error, setError] = useState(undefined)
    const [currencyInputOpen, setCurrencyInputOpen] = useState(false)
    const [currencyOptions, setCurrencyOptions] = useState([])
    const [selectedCurrency, setSelectedCurrency] = useState(undefined)
    const [currencySearch, setCurrencySearch] = useState("")

    const units = ["box", "cm", "dz", "ft", "g", "in", "kg", "km", "lb", "mg", "ml", "m", "pcs"]

    const token = localStorage.getItem("_crm__token")

    const createProduct = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/create-product`, {
            token,
            producttype: producType,
            productname: productName,
            productdescription: productDescription,
            unit: productUnit,
            currency: selectedCurrency,
            sellingprice: sellingPrice,
            costprice: costPrice
        })

        if (data.success) {
            setOpen(false)
            setProductUpdatedRefresh(prev => prev + 1)
        }
        else {
            setError(data.message)
        }
    }

    const fetchCurrency = async () => {
        try {
            const response = await axios.post(`${api}/Accounting/fetch-currency`, { token })
            const { data } = response

            if (data.success) {
                setCurrencyOptions(data.currency)
            }
        }
        catch (error) {
            console.log(error)
        }
    }

    const handleCurrencyClick = (option) => {
        setSelectedCurrency(option._id)
        setCurrencyInputOpen(false)
    }

    useEffect(() => {
        fetchCurrency()
    }, [])

    return (
        <div className="_2swz">
            <BootstrapDialog
                onClose={() => setOpen(false)}
                aria-labelledby="customized-dialog-title"
                className='customize_popup'
                open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    New Item
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <div className="_2gjv" style={{ padding: "10px 30px" }}>
                        <div className="customer-input">
                            <FormControl component="div" style={{ width: '150px' }} margin="normal">
                                <FormLabel component="legend">Type</FormLabel>
                            </FormControl>
                            <RadioGroup
                                value={producType}
                                onChange={e => setProductType(e.target.value)}
                                className="customer-input" row aria-label="customer-input" name="customer-input">
                                <FormControlLabel value="goods" control={<Radio />} label="Goods" />
                                <FormControlLabel value="service" control={<Radio />} label="Service" />
                            </RadioGroup>
                        </div>
                        <div>
                            <div className="customer-input">
                                <FormControl component="div" style={{ width: '150px' }} margin="normal">
                                    <FormLabel component="legend">Name</FormLabel>
                                </FormControl>
                                <Box display="flex" alignItems="center">
                                    <input
                                        value={productName}
                                        onChange={e => setProductName(e.target.value)}
                                        type="text" name="Name" className="custom-input-popup" placeholder="Product Name" style={{ marginRight: '10px' }} />
                                </Box>
                            </div>
                        </div>
                        <div>
                            <div className="customer-input">
                                <FormControl component="div" style={{ width: '150px' }} margin="normal">
                                    <FormLabel component="legend">Unit</FormLabel>
                                </FormControl>
                                <select
                                    value={productUnit}
                                    onChange={e => setProductUnit(e.target.value)}
                                    name="Company" className="custom-input-popup" id="cars">
                                    {units.map((unit, index) => {
                                        return (
                                            <option key={index} value={unit}>{unit}</option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div>
                        <div>
                            <div className="customer-input">
                                <FormControl component="div" style={{ width: '150px' }} margin="normal">
                                    <FormLabel component="legend">Currency</FormLabel>
                                </FormControl>
                                <div className="whingy-peep">
                                    <div className="peep-peep">
                                        <div
                                            onClick={() => setCurrencyInputOpen(!currencyInputOpen)}
                                            className="salients-rap"
                                        >
                                            {selectedCurrency && currencyOptions.find(option => option._id === selectedCurrency)?.name || 'Select Currency'}
                                        </div>
                                        {currencyInputOpen ? (
                                            <div onClick={(e) => e.stopPropagation()} className="cirrus-tee country-scroll">
                                                <input
                                                    style={{ outline: "none" }}
                                                    placeholder="Search"
                                                    value={currencySearch}
                                                    onChange={e => setCurrencySearch(e.target.value)}
                                                />
                                                <div className="exhausts-poxy">
                                                {currencyOptions.filter(item => item.name.toLowerCase().includes(currencySearch.toLowerCase()) || item.code.toLowerCase().includes(currencySearch.toLowerCase())).map((option, index) => (
                                                    <button
                                                        key={index}
                                                        onClick={() => handleCurrencyClick(option)}
                                                        className="term-button"
                                                    >
                                                        {option.code}- {option.name}
                                                    </button>

                                                ))}
                                                </div>
                                            </div>
                                        ) : undefined}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="customer-input">
                                <FormControl component="div" style={{ width: '150px' }} margin="normal">
                                    <FormLabel component="legend">Selling Price</FormLabel>
                                </FormControl>
                                <Box display="flex" alignItems="center">
                                    <input
                                        value={sellingPrice}
                                        onChange={e => {
                                            isNaN(e.target.value) === false && setSellingPrice(e.target.value)
                                        }}
                                        type="text" name="Name" className="custom-input-popup" placeholder="Selling Price" style={{ marginRight: '10px' }} />
                                </Box>
                            </div>
                        </div>
                        <div>
                            <div className="customer-input">
                                <FormControl component="div" style={{ width: '150px' }} margin="normal">
                                    <FormLabel component="legend">Cost Price</FormLabel>
                                </FormControl>
                                <Box display="flex" alignItems="center">
                                    <input
                                        value={costPrice}
                                        onChange={e => {
                                            isNaN(e.target.value) === false && setCostPrice(e.target.value)
                                        }}
                                        type="text" name="Name" className="custom-input-popup" placeholder="Cost Price" style={{ marginRight: '10px' }} />
                                </Box>
                            </div>
                        </div>
                        <div>
                            <div className="customer-input">
                                <FormControl component="div" style={{ width: '150px' }} margin="normal">
                                    <FormLabel component="legend">Description</FormLabel>
                                </FormControl>
                                <Box display="flex" alignItems="center">
                                    <textarea
                                        value={productDescription}
                                        onChange={e => setProductDescription(e.target.value)}
                                        type="text" name="Name" className="custom-input-popup" placeholder="Description" style={{ marginRight: '10px' }} />
                                </Box>
                            </div>
                        </div>
                        <div style={{ color: "red", marginTop: "10px" }}>
                            <span>{error}</span>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => createProduct()}>
                        Save changes
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div >
    )
}

export default AddNewItem;

